import { Link } from 'react-router';

const Home = () => (
  <div className="container">
    <div className="home page">
      <h1 className="name">Gleb Husky</h1>
      <Link to="/projects" className="link home-link">Projects</Link>
      <Link to="/articles" className="link home-link">Articles</Link>
      <Link to="/contact" className="link home-link">Contact</Link>
    </div>
  </div>
);

export default Home;
